export enum TroubleShootingFormFieldsEnum {
    PRODUCT_CODE = "product_code",
    PLATFORM = "platform",
    TIME_RANGE = "time_range",
    METRIC_PROBLEMS = "metric_problems",
    LAYERS = "layers",
    COUNTRY_CODE = "country_code",
    PREDICTION_VIEW = "prediction_view",
}
